package com.example.mystybag.biometricUtils.helpers

enum class BiometricAuthenticationType {
    NONE,
    FINGERPRINT,
    FACE
}

enum class BiometricErrorResult {
    NONE,
    USER_CANCELED,
    LOCKED
}